import React from 'react';
import { Forms, StringHelpers, SystemText } from 'e4shared';

export const Web = ({ assets, allowMultiple, onAdd, mediaOnly }) => {
    const [urls, setUrls] = React.useState(assets);
    const [url, setUrl] = React.useState('');
    const [error, setError] = React.useState('');

    const st = (path, ...rest) => SystemText(`Admin/Forms/FilePicker/Web/${path}`, ...rest);

    React.useEffect(() => {
        urls && onAdd(urls, 'url');
    }, [urls]);

    const validate = () => {
        const regex = StringHelpers.regExs.URL;
        return StringHelpers.matchRegEx(regex, url);
    };

    const addUrl = () => {
        if (!url) {
            setError(st('Errors/NoUrl'));
        } else if (validate() === false) {
            setError(st('Errors/InvalidUrl'));
        } else if (urls.find(u => u.url === url)) {
            setError(st('Errors/DuplicateUrl'));
        } else {
            if (allowMultiple) {
                setUrls(urls.filter(u => u.url !== url).concat([{ url, name: url }]));
            } else {
                setUrls([{ url, name: url }]);
            }
            setUrl('');
            setError('');
        }
    };

    const removeUrl = remove => {
        setUrls(urls.filter(u => u.url !== remove.url));
    };

    return (
        <div>
            <Forms.Text
                value={url}
                data-testid="text-web-url"
                error={error}
                onChange={x => setUrl(x)}
                label={st('Url/Label')}
                help={mediaOnly ? st('Url/Help') : ''}
                onSubmit={addUrl}
                placeholder={st('Url/Placeholder')}
            />
            <button id="add-button" className="btn btn-primary mb10" onClick={addUrl}>
                {st('Buttons/Add')}
            </button>
            {urls.length > 0 && (
                <div className="mt10">
                    <label>{st('Urls')}</label>
                    {urls
                        .sort((a, b) => (a.url > b.url ? 1 : -1))
                        .map((u, i) => {
                            return (
                                <div key={`file-${i}`} className="mb5 flex flex-center">
                                    <i className={`fa fa-globe mr5`} />
                                    <span className="ellipsis500 flex-grow">{u.url}</span>
                                    <i
                                        className="ml5 text-danger fa fa-trash pointer text-right"
                                        title={st('Remove', u.url)}
                                        onClick={() => removeUrl(u)}
                                        data-testid="remove-link"
                                    />
                                </div>
                            );
                        })}
                </div>
            )}
        </div>
    );
};

export default Web;
